import { useState, useEffect } from 'react';

const SLIM_DESIGN_THRESHOLD = 350; // px

export const useSlimDesign = (maxHeight: number = SLIM_DESIGN_THRESHOLD): boolean => {
  const [isCompact, setIsCompact] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-height: ${maxHeight}px)`);

    setIsCompact(mediaQuery.matches);

    const handleResize = (event: MediaQueryListEvent): void => {
      setIsCompact(event.matches);
    };

    mediaQuery.addEventListener('change', handleResize);

    return () => {
      mediaQuery.removeEventListener('change', handleResize);
    };
  }, [maxHeight]);

  return isCompact;
};
